document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function (el) {
        if (el.textContent.trim() === '') {
            el.remove();
        }
    });
});
